import { Subscription } from 'rxjs';
import { Component, OnInit } from '@angular/core';
import { User } from '../../services/auth.service';
import { select, Store } from '@ngrx/store';
import { IState } from '../../store/root.reducer';
import { Router } from '@angular/router';

@Component({
  selector: 'app-redirect',
  templateUrl: './redirect.component.html',
  styleUrls: ['./redirect.component.scss']
})
export class RedirectComponent implements OnInit {
  subscriptions: Subscription[] = [];
  currentUser = <User>{};

  constructor(private store: Store<IState>, private router: Router) { }

  ngOnInit() {
    this.subscriptions.push(this.store.pipe(select((store: IState) => store.currentUser)).subscribe(currentUser => {
      this.currentUser = currentUser;
      if (this.currentUser.userType === 1) {
        this.router.navigate(['shop/partners']);
      }
      if (this.currentUser.userType === 2) {
        this.router.navigate(['partners']);
      }
    }));
  }

}
